import React from "react";
import { Box, Container, Link, Typography, Stack } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import { config } from "../core/service/config.service";

const SEC_A = "section_a";
const SEC_B = "section_b";
const SEC_C = "section_c";
const SEC_D = "section_d";

const SectionA = (detail) => {
  const {
    AssessMainProgressAchieved,
    ListJournalSubject,
    additionalDocument,
    additionalInformNote,
    researchPlanRelevantIndicates,
    whatYourStatus
  } = detail;

  return (
    <Container>
      <Box>
        <Typography variant="h6" sx={{ paddingTop: 4 }}>
          Present progress (Section A)
        </Typography>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Status:</Typography>
          <Typography>{whatYourStatus}</Typography>
          <Typography variant="subtitle1">Main progress achieved:</Typography>
          <Typography>{AssessMainProgressAchieved}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1">File Research plan:</Typography>
          <Link
            href={
              researchPlanRelevantIndicates
                ? `${config.host_api}download/${researchPlanRelevantIndicates}`
                : null
            }
          >
            {researchPlanRelevantIndicates?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1">
            List of Journal and Subject:
          </Typography>
          <Typography>{ListJournalSubject}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Note:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{additionalInformNote}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1">File additional document:</Typography>
          <Link
            href={
              additionalDocument
                ? `${config.host_api}download/${additionalDocument}`
                : null
            }
          >
            {additionalDocument?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>
      </Box>
    </Container>
  );
};

const SectionB = (detail) => {
  const {
    additionalDocumentSecB,
    additionalInformNoteSecB,
    attachEvidenceTier1Paper,
    attachEvidenceUniversityInstituteRanking,
    authors,
    coResearcherUniversityInstituteName,
    coResearcherUniversityInstituteRanking,
    coauthorAbroadPublication,
    coauthorName,
    correspondingAuthorName,
    documentsShowingsSubmission,
    firstAuthorName,
    journal,
    journalRanking,
    manuscriptID,
    receivedDate,
    revisedDate,
    subjectAreaCategory,
    submissionStatus,
    submitDate,
    supportedSecondCenturyFund,
    typeManuscript,
    uploadManuscript
  } = detail;

  return (
    <Container>
      <Box>
        <Typography variant="h6" sx={{ paddingTop: 4 }}>
          Present progress (Section B)
        </Typography>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Status:</Typography>
          <Typography>{submissionStatus}</Typography>
          <Typography variant="subtitle1">Submit Date:</Typography>
          <Typography>{moment(submitDate).format("DD/MM/YY")}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Received Date:</Typography>
          <Typography>{moment(receivedDate).format("DD/MM/YY")}</Typography>
          <Typography variant="subtitle1">Revised Date:</Typography>
          <Typography>{moment(revisedDate).format("DD/MM/YY")}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Manuscript ID:</Typography>
          <Typography>{manuscriptID}</Typography>
          <Typography variant="subtitle1">Type Manuscript:</Typography>
          <Typography>{typeManuscript}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Journal:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{journal}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Subject area and category:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{subjectAreaCategory}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Journal ranking:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{journalRanking}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Authors:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{authors}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            First author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{firstAuthorName}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Corresponding author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {correspondingAuthorName}
          </Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Co-author:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {coauthorAbroadPublication === 1 && "Have"}
          </Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Co-author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{coauthorName}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            University:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {coResearcherUniversityInstituteName}
          </Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            University ranking:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {coResearcherUniversityInstituteRanking}
          </Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1">
            File evidence of Co-researcher's University ranking:
          </Typography>
          <Link
            href={
              attachEvidenceUniversityInstituteRanking
                ? `${config.host_api}download/${attachEvidenceUniversityInstituteRanking}`
                : null
            }
          >
            {attachEvidenceUniversityInstituteRanking?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Acknowledgement in the statement:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {supportedSecondCenturyFund}
          </Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1">File manuscript :</Typography>
          <Link
            href={
              uploadManuscript
                ? `${config.host_api}download/${uploadManuscript}`
                : null
            }
          >
            {uploadManuscript?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1">
            File evidence or relevant:
          </Typography>
          <Link
            href={
              documentsShowingsSubmission
                ? `${config.host_api}download/${documentsShowingsSubmission}`
                : null
            }
          >
            {documentsShowingsSubmission?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1">
            File evidence of Tier 1 paper:
          </Typography>
          <Link
            href={
              attachEvidenceTier1Paper
                ? `${config.host_api}download/${attachEvidenceTier1Paper}`
                : null
            }
          >
            {attachEvidenceTier1Paper?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Note:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {additionalInformNoteSecB}
          </Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1">File additional document:</Typography>
          <Link
            href={
              additionalDocumentSecB
                ? `${config.host_api}download/${additionalDocumentSecB}`
                : null
            }
          >
            {additionalDocumentSecB?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>
      </Box>
    </Container>
  );
};

const SectionBNoCo = (detail) => {
  const {
    additionalDocumentSecB,
    additionalInformNoteSecB,
    attachEvidenceTier1Paper,
    authors,
    coauthorAbroadPublication,
    correspondingAuthorName,
    documentsShowingsSubmission,
    firstAuthorName,
    journal,
    journalRanking,
    manuscriptID,
    receivedDate,
    revisedDate,
    subjectAreaCategory,
    submissionStatus,
    submitDate,
    supportedSecondCenturyFund,
    typeManuscript,
    uploadManuscript
  } = detail;

  return (
    <Container>
      <Box>
        <Typography variant="h6" sx={{ paddingTop: 4 }}>
          Present progress (Section B)
        </Typography>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Status:</Typography>
          <Typography>{submissionStatus}</Typography>
          <Typography variant="subtitle1">Submit Date:</Typography>
          <Typography>{moment(submitDate).format("DD/MM/YY")}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Received Date:</Typography>
          <Typography>{moment(receivedDate).format("DD/MM/YY")}</Typography>
          <Typography variant="subtitle1">Revised Date:</Typography>
          <Typography>{moment(revisedDate).format("DD/MM/YY")}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Manuscript ID:</Typography>
          <Typography>{manuscriptID}</Typography>
          <Typography variant="subtitle1">Type Manuscript:</Typography>
          <Typography>{typeManuscript}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Journal:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{journal}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Subject area and category:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{subjectAreaCategory}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Journal ranking:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{journalRanking}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Authors:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{authors}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            First author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{firstAuthorName}</Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Corresponding author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {correspondingAuthorName}
          </Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Co-author:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {coauthorAbroadPublication === 0 && "Not have"}
          </Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Acknowledgement in the statement:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {supportedSecondCenturyFund}
          </Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1">File manuscript :</Typography>
          <Link
            href={
              uploadManuscript
                ? `${config.host_api}download/${uploadManuscript}`
                : null
            }
          >
            {uploadManuscript?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1">
            File evidence or relevant:
          </Typography>
          <Link
            href={
              documentsShowingsSubmission
                ? `${config.host_api}download/${documentsShowingsSubmission}`
                : null
            }
          >
            {documentsShowingsSubmission?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1">
            File evidence of Tier 1 paper:
          </Typography>
          <Link
            href={
              attachEvidenceTier1Paper
                ? `${config.host_api}download/${attachEvidenceTier1Paper}`
                : null
            }
          >
            {attachEvidenceTier1Paper?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Note:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {additionalInformNoteSecB}
          </Typography>
        </Stack>

        <Stack direction="row" sx={{ paddingTop: 1 }} spacing={1}>
          <Typography variant="subtitle1">File additional document:</Typography>
          <Link
            href={
              additionalDocumentSecB
                ? `${config.host_api}download/${additionalDocumentSecB}`
                : null
            }
          >
            {additionalDocumentSecB?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>
      </Box>
    </Container>
  );
};

const SectionC = (detail) => {
  const {
    acceptedDateSecC,
    additionalDocumentSecC,
    additionalInformNoteSecC,
    attachEvidenceTier1PaperSecC,
    attachEvidenceUniversityInstituteRankingSecC,
    authorsSecC,
    coResearcherUniversityInstituteNameSecC,
    coResearcherUniversityInstituteRankingSecC,
    coauthorAbroadPublicationSecC,
    coauthorNameSecC,
    correspondingAuthorNameSecC,
    documentsShowingsSubmissionSecC,
    firstAuthorNameSecC,
    journalRankingSecC,
    journalSecC,
    manuscriptIDSecC,
    publicationAcceptedEvidenceSecC,
    receivedDateSecC,
    revisedDateSecC,
    subjectAreaCategorySecC,
    submitDateSecC,
    supportedSecondCenturyFundSecC,
    typeManuscriptSecC,
    uploadManuscriptSecC
  } = detail;

  return (
    <Container>
      <Box>
        <Typography variant="h6" sx={{ paddingTop: 4 }}>
          Present progress (Section C)
        </Typography>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Submit Date:</Typography>
          <Typography>{moment(submitDateSecC).format("DD/MM/YY")}</Typography>
          <Typography variant="subtitle1">Received Date:</Typography>
          <Typography>{moment(receivedDateSecC).format("DD/MM/YY")}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Revised Date:</Typography>
          <Typography>{moment(revisedDateSecC).format("DD/MM/YY")}</Typography>
          <Typography variant="subtitle1">Accepted Date:</Typography>
          <Typography>{moment(acceptedDateSecC).format("DD/MM/YY")}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Manuscript ID:</Typography>
          <Typography>{manuscriptIDSecC}</Typography>
          <Typography variant="subtitle1">Type Manuscript:</Typography>
          <Typography>{typeManuscriptSecC}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Journal:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{journalSecC}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Subject area and category:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {subjectAreaCategorySecC}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Journal ranking:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{journalRankingSecC}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Authors:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{authorsSecC}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            First author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{firstAuthorNameSecC}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Corresponding author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {correspondingAuthorNameSecC}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Co-author:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {coauthorAbroadPublicationSecC === 1 && "Have"}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Co-author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{coauthorNameSecC}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            University:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {coResearcherUniversityInstituteNameSecC}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            University ranking:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {coResearcherUniversityInstituteRankingSecC}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            File evidence of Co-researcher's University ranking:
          </Typography>
          <Link
            href={
              attachEvidenceUniversityInstituteRankingSecC
                ? `${config.host_api}download/${attachEvidenceUniversityInstituteRankingSecC}`
                : null
            }
          >
            {attachEvidenceUniversityInstituteRankingSecC?.split("-").pop() ||
              " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Acknowledgement in the statement:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {supportedSecondCenturyFundSecC}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">File manuscript :</Typography>
          <Link
            href={
              uploadManuscriptSecC
                ? `${config.host_api}download/${uploadManuscriptSecC}`
                : null
            }
          >
            {uploadManuscriptSecC?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File evidence or relevant:
          </Typography>
          <Link
            href={
              documentsShowingsSubmissionSecC
                ? `${config.host_api}download/${documentsShowingsSubmissionSecC}`
                : null
            }
          >
            {documentsShowingsSubmissionSecC?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File research publication or accepted evidence:
          </Typography>
          <Link
            href={
              publicationAcceptedEvidenceSecC
                ? `${config.host_api}download/${publicationAcceptedEvidenceSecC}`
                : null
            }
          >
            {publicationAcceptedEvidenceSecC?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File evidence of Tier 1 paper:
          </Typography>
          <Link
            href={
              attachEvidenceTier1PaperSecC
                ? `${config.host_api}download/${attachEvidenceTier1PaperSecC}`
                : null
            }
          >
            {attachEvidenceTier1PaperSecC?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Note:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {additionalInformNoteSecC}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">File additional document:</Typography>
          <Link
            href={
              additionalDocumentSecC
                ? `${config.host_api}download/${additionalDocumentSecC}`
                : null
            }
          >
            {additionalDocumentSecC?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>
      </Box>
    </Container>
  );
};

const SectionCNoCo = (detail) => {
  const {
    acceptedDateSecC,
    additionalDocumentSecC,
    additionalInformNoteSecC,
    attachEvidenceTier1PaperSecC,
    authorsSecC,
    coauthorAbroadPublicationSecC,
    correspondingAuthorNameSecC,
    documentsShowingsSubmissionSecC,
    firstAuthorNameSecC,
    journalRankingSecC,
    journalSecC,
    manuscriptIDSecC,
    publicationAcceptedEvidenceSecC,
    receivedDateSecC,
    revisedDateSecC,
    subjectAreaCategorySecC,
    submitDateSecC,
    supportedSecondCenturyFundSecC,
    typeManuscriptSecC,
    uploadManuscriptSecC
  } = detail;

  return (
    <Container>
      <Box>
        <Typography variant="h6" sx={{ paddingTop: 4 }}>
          Present progress (Section C)
        </Typography>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Submit Date:</Typography>
          <Typography>{moment(submitDateSecC).format("DD/MM/YY")}</Typography>
          <Typography variant="subtitle1">Received Date:</Typography>
          <Typography>{moment(receivedDateSecC).format("DD/MM/YY")}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Revised Date:</Typography>
          <Typography>{moment(revisedDateSecC).format("DD/MM/YY")}</Typography>
          <Typography variant="subtitle1">Accepted Date:</Typography>
          <Typography>{moment(acceptedDateSecC).format("DD/MM/YY")}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Manuscript ID:</Typography>
          <Typography>{manuscriptIDSecC}</Typography>
          <Typography variant="subtitle1">Type Manuscript:</Typography>
          <Typography>{typeManuscriptSecC}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Journal:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{journalSecC}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Subject area and category:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {subjectAreaCategorySecC}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Journal ranking:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{journalRankingSecC}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Authors:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{authorsSecC}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            First author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{firstAuthorNameSecC}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Corresponding author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {correspondingAuthorNameSecC}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Co-author:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {coauthorAbroadPublicationSecC === 0 && "Not have"}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Acknowledgement in the statement:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {supportedSecondCenturyFundSecC}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">File manuscript :</Typography>
          <Link
            href={
              uploadManuscriptSecC
                ? `${config.host_api}download/${uploadManuscriptSecC}`
                : null
            }
          >
            {uploadManuscriptSecC?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File evidence or relevant:
          </Typography>
          <Link
            href={
              documentsShowingsSubmissionSecC
                ? `${config.host_api}download/${documentsShowingsSubmissionSecC}`
                : null
            }
          >
            {documentsShowingsSubmissionSecC?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File research publication or accepted evidence:
          </Typography>
          <Link
            href={
              publicationAcceptedEvidenceSecC
                ? `${config.host_api}download/${publicationAcceptedEvidenceSecC}`
                : null
            }
          >
            {publicationAcceptedEvidenceSecC?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File evidence of Tier 1 paper:
          </Typography>
          <Link
            href={
              attachEvidenceTier1PaperSecC
                ? `${config.host_api}download/${attachEvidenceTier1PaperSecC}`
                : null
            }
          >
            {attachEvidenceTier1PaperSecC?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Note:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {additionalInformNoteSecC}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">File additional document:</Typography>
          <Link
            href={
              additionalDocumentSecC
                ? `${config.host_api}download/${additionalDocumentSecC}`
                : null
            }
          >
            {additionalDocumentSecC?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>
      </Box>
    </Container>
  );
};

const SectionD = (detail) => {
  const {
    receivedDateSecD,
    submitDateSecD,
    acceptedDateSecD,
    revisedDateSecD,
    publishedDateSecD,
    additionalDocumentSecD,
    manuscriptIDSecD,
    typeManuscriptSecD,
    journalSecD,
    subjectAreaCategorySecD,
    journalRankingSecD,
    authorsSecD,
    firstAuthorNameSecD,
    correspondingAuthorNameSecD,
    coauthorAbroadPublicationSecD,
    coauthorNameSecD,
    coResearcherUniversityInstituteNameSecD,
    coResearcherUniversityInstituteRankingSecD,
    supportedSecondCenturyFundSecD,
    uploadManuscriptSecD,
    documentsShowingsSubmissionSecD,
    publicationAcceptedEvidenceSecD,
    attachEvidenceTier1PaperSecD,
    attachEvidenceUniversityInstituteRankingSecD,
    additionalInformNoteSecD
  } = detail;

  return (
    <Container>
      <Box>
        <Typography variant="h6" sx={{ paddingTop: 4 }}>
          Present progress (Section D)
        </Typography>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Submit Date:</Typography>
          <Typography>{moment(submitDateSecD).format("DD/MM/YY")}</Typography>
          <Typography variant="subtitle1">Received Date:</Typography>
          <Typography>{moment(receivedDateSecD).format("DD/MM/YY")}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Revised Date:</Typography>
          <Typography>{moment(revisedDateSecD).format("DD/MM/YY")}</Typography>
          <Typography variant="subtitle1">Accepted Date:</Typography>
          <Typography>{moment(acceptedDateSecD).format("DD/MM/YY")}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Published Date:</Typography>
          <Typography>{publishedDateSecD}</Typography>
          <Typography variant="subtitle1">Manuscript ID:</Typography>
          <Typography>{manuscriptIDSecD}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Type Manuscript:</Typography>
          <Typography>{typeManuscriptSecD}</Typography>
          <Typography variant="subtitle1">Journal:</Typography>
          <Typography>{journalSecD}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Subject area and category:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {subjectAreaCategorySecD}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Journal ranking:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{journalRankingSecD}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Authors:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{authorsSecD}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            First author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{firstAuthorNameSecD}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Corresponding author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {correspondingAuthorNameSecD}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Co-author:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {coauthorAbroadPublicationSecD === 1 && "Have"}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Co-author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{coauthorNameSecD}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            University:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {coResearcherUniversityInstituteNameSecD}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            University ranking:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {coResearcherUniversityInstituteRankingSecD}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File evidence of Co-researcher's University ranking:
          </Typography>
          <Link
            href={
              attachEvidenceUniversityInstituteRankingSecD
                ? `${config.host_api}download/${attachEvidenceUniversityInstituteRankingSecD}`
                : null
            }
          >
            {attachEvidenceUniversityInstituteRankingSecD?.split("-").pop() ||
              " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Acknowledgement in the statement:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {supportedSecondCenturyFundSecD}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">File manuscript :</Typography>
          <Link
            href={
              uploadManuscriptSecD
                ? `${config.host_api}download/${uploadManuscriptSecD}`
                : null
            }
          >
            {uploadManuscriptSecD?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File evidence or relevant:
          </Typography>
          <Link
            href={
              documentsShowingsSubmissionSecD
                ? `${config.host_api}download/${documentsShowingsSubmissionSecD}`
                : null
            }
          >
            {documentsShowingsSubmissionSecD?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File research publication or accepted evidence:
          </Typography>
          <Link
            href={
              publicationAcceptedEvidenceSecD
                ? `${config.host_api}download/${publicationAcceptedEvidenceSecD}`
                : null
            }
          >
            {publicationAcceptedEvidenceSecD?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File evidence of Tier 1 paper:
          </Typography>
          <Link
            href={
              attachEvidenceTier1PaperSecD
                ? `${config.host_api}download/${attachEvidenceTier1PaperSecD}`
                : null
            }
          >
            {attachEvidenceTier1PaperSecD?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Note:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {additionalInformNoteSecD}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">File additional document:</Typography>
          <Link
            href={
              additionalDocumentSecD
                ? `${config.host_api}download/${additionalDocumentSecD}`
                : null
            }
          >
            {additionalDocumentSecD?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>
      </Box>
    </Container>
  );
};

const SectionDNoCo = (detail) => {
  const {
    receivedDateSecD,
    submitDateSecD,
    acceptedDateSecD,
    revisedDateSecD,
    publishedDateSecD,
    additionalDocumentSecD,
    manuscriptIDSecD,
    typeManuscriptSecD,
    journalSecD,
    subjectAreaCategorySecD,
    journalRankingSecD,
    authorsSecD,
    firstAuthorNameSecD,
    correspondingAuthorNameSecD,
    coauthorAbroadPublicationSecD,
    supportedSecondCenturyFundSecD,
    uploadManuscriptSecD,
    documentsShowingsSubmissionSecD,
    publicationAcceptedEvidenceSecD,
    attachEvidenceTier1PaperSecD,
    additionalInformNoteSecD
  } = detail;

  return (
    <Container>
      <Box>
        <Typography variant="h6" sx={{ paddingTop: 4 }}>
          Present progress (Section D)
        </Typography>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Submit Date:</Typography>
          <Typography>{moment(submitDateSecD).format("DD/MM/YY")}</Typography>
          <Typography variant="subtitle1">Received Date:</Typography>
          <Typography>{moment(receivedDateSecD).format("DD/MM/YY")}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Revised Date:</Typography>
          <Typography>{moment(revisedDateSecD).format("DD/MM/YY")}</Typography>
          <Typography variant="subtitle1">Accepted Date:</Typography>
          <Typography>{moment(acceptedDateSecD).format("DD/MM/YY")}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Published Date:</Typography>
          <Typography>{publishedDateSecD}</Typography>
          <Typography variant="subtitle1">Manuscript ID:</Typography>
          <Typography>{manuscriptIDSecD}</Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={12}
          variant="subtitle2"
          sx={{ paddingTop: 1 }}
        >
          <Typography variant="subtitle1">Type Manuscript:</Typography>
          <Typography>{typeManuscriptSecD}</Typography>
          <Typography variant="subtitle1">Journal:</Typography>
          <Typography>{journalSecD}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Subject area and category:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {subjectAreaCategorySecD}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Journal ranking:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{journalRankingSecD}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Authors:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{authorsSecD}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            First author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>{firstAuthorNameSecD}</Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Corresponding author's name:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {correspondingAuthorNameSecD}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Co-author:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {coauthorAbroadPublicationSecD === 0 && "Not have"}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Acknowledgement in the statement:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {supportedSecondCenturyFundSecD}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">File manuscript :</Typography>
          <Link
            href={
              uploadManuscriptSecD
                ? `${config.host_api}download/${uploadManuscriptSecD}`
                : null
            }
          >
            {uploadManuscriptSecD?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File evidence or relevant:
          </Typography>
          <Link
            href={
              documentsShowingsSubmissionSecD
                ? `${config.host_api}download/${documentsShowingsSubmissionSecD}`
                : null
            }
          >
            {documentsShowingsSubmissionSecD?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File research publication or accepted evidence:
          </Typography>
          <Link
            href={
              publicationAcceptedEvidenceSecD
                ? `${config.host_api}download/${publicationAcceptedEvidenceSecD}`
                : null
            }
          >
            {publicationAcceptedEvidenceSecD?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">
            File evidence of Tier 1 paper:
          </Typography>
          <Link
            href={
              attachEvidenceTier1PaperSecD
                ? `${config.host_api}download/${attachEvidenceTier1PaperSecD}`
                : null
            }
          >
            {attachEvidenceTier1PaperSecD?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>

        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
            Note:
          </Typography>
          <Typography sx={{ paddingTop: 1 }}>
            {additionalInformNoteSecD}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ paddingTop: 1 }}>
          <Typography variant="subtitle1">File additional document:</Typography>
          <Link
            href={
              additionalDocumentSecD
                ? `${config.host_api}download/${additionalDocumentSecD}`
                : null
            }
          >
            {additionalDocumentSecD?.split("-").pop() || " "}
          </Link>
          <DownloadIcon />
        </Stack>
      </Box>
    </Container>
  );
};

export default function ApprovePostDocModalSecs({ detail }) {
  const {
    form_nm,
    coauthorAbroadPublication,
    coauthorAbroadPublicationSecC,
    coauthorAbroadPublicationSecD
  } = detail;

  return (
    <>
      {form_nm === SEC_A && SectionA(detail)}
      {form_nm === SEC_B
        ? coauthorAbroadPublication === 1
          ? SectionB(detail)
          : SectionBNoCo(detail)
        : null}
      {form_nm === SEC_C
        ? coauthorAbroadPublicationSecC === 1
          ? SectionC(detail)
          : SectionCNoCo(detail)
        : null}
      {form_nm === SEC_D
        ? coauthorAbroadPublicationSecD === 1
          ? SectionD(detail)
          : SectionDNoCo(detail)
        : null}
    </>
  );
}
